export default __webpack_public_path__ + "static/media/comercial.b320b880.jpg";